import type { NavItem, NavSection } from "../components/layout/nav-config.js";

/** Primary rail order from the approved staff shell (28 Aug 2026). */
export const STAFF_RAIL_PRIMARY_IDS = [
  "insights-home",
  "ideation-maps",
  "documents",
  "ask-insights",
] as const;

/**
 * Pull the four primary destinations out of the filtered nav inventory.
 * Everything else stays under "All modules" so existing routes remain reachable.
 */
export function splitStaffRail(sections: NavSection[]): {
  primary: NavItem[];
  more: NavSection[];
} {
  const byId = new Map<string, NavItem>();
  for (const section of sections) {
    for (const item of section.items) byId.set(item.id, item);
  }
  const primary = STAFF_RAIL_PRIMARY_IDS.flatMap((id) => {
    const item = byId.get(id);
    return item ? [item] : [];
  });
  const primaryIds = new Set(primary.map((item) => item.id));
  const more = sections
    .map((section) => ({
      ...section,
      items: section.items.filter((item) => !primaryIds.has(item.id)),
    }))
    .filter((section) => section.items.length > 0);
  return { primary, more };
}
